import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useStyles } from "../../../shared/styles/useStyles";
import clsx from "clsx";
import { Form, Formik, FormikHelpers } from "formik";

import { AppState } from "../../../redux/reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  uiCloseModalAction,
  uiCloseModalInfo,
} from "../../../redux/actions/uiActions";
import Checkbox from "@material-ui/core/Checkbox";
import { useEffect, useState } from "react";
import { IFilesCorrespondence } from "../../../interfaces/Correspondence";
import {
  changeTrdCorrtespondenciafile,
  startSetCorrespondence,
} from "../../../redux/actions/correspondenceActions";
import { setActiveDocument } from "../../../redux/actions/fuidActions";
import {
  startSetAnnotationTrd,
  startSetFuid,
} from "../../../redux/actions/documentManagmentActions";
import {
  CorrespondenceappendDocsFileToTrdFileList,
  CorrespondenceDigitalSupportFileToTrdFileList,
} from "../../../module/documentManagment/adapter/documentManagmentAdapter";
import { IClassificationTrdFileDoc } from "../../../module/documentManagment/doc/IClassificationTrdFileDoc";
import { IClassificationTrdDoc } from "../../../module/documentManagment/doc/IClassificationTrdDoc";
export interface ICheckFiles extends IFilesCorrespondence {
  checked: boolean;
  annotationId?: string;
}

interface Props {
  component?: "ExpedientManagment" | "ExpedientCentralFile" | "Other";
}
export const ClassifyTrdForm = ({ component = "Other" }: Props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    series: allSeries,
    latestProductionOffices,
    subSeries: allSubseries,
    documentalType: allDocumentalType,
    versions,
  } = useSelector((state: AppState) => state.trd);

  const { activeCorrespondence } = useSelector(
    (state: AppState) => state.documentManagment
  );
  const [parseCorresFiles, setParseCorresFiles] = useState<
    IClassificationTrdFileDoc[]
  >([]);
  const [selectedFile, setSelectedFile] = useState<IClassificationTrdFileDoc[]>(
    []
  );

  const { user } = useSelector((state: AppState) => state.auth);

  const allSelected = selectedFile.length === parseCorresFiles.length;

  const [ProductionOffice, setProductionOffice] = useState<any[]>([]);
  const [selectedProductionOffice, setSelectedProductionOffice] = useState({});
  const [disabledOffice, setDisabledOffice] = useState(false);

  const [series, setSeries] = useState(allSeries);
  const [selectedseries, setSelectedseries] = useState({});

  const [subSeries, setSubSeries] = useState(allSubseries);
  const [selectedsubSeries, setSelectedsubSeries] = useState({});

  const [documentalType, setDocumentalType] = useState(allDocumentalType);
  const [selecteddocumentalType, setSelecteddocumentalType] = useState({});

  const { corresAnnotations } = useSelector(
    (state: AppState) => state.documentManagment
  );

  const { activeExpedient: FuidDocumentManagement } = useSelector(
    (state: AppState) => state.fuid
  );
  const { activeExpedientFileModule: FuidFilesModule } = useSelector(
    (state: AppState) => state.fileModule
  );

  const expedient =
    component === "ExpedientCentralFile"
      ? FuidFilesModule
      : FuidDocumentManagement;

  const { activeDocument } = useSelector((state: AppState) => state.fuid);

  const [selected, setSelected] = useState({
    productionOffice: activeDocument
      ? (allDocumentalType.find(
          (doc) => doc.idDocumentalType === activeDocument.documentalType
        )?.idProductionOffice as string)
      : "",
    series: activeDocument
      ? (allDocumentalType.find(
          (doc) => doc.idDocumentalType === activeDocument.documentalType
        )?.idSerie as string)
      : "",
    subseries: activeDocument
      ? (allDocumentalType.find(
          (doc) => doc.idDocumentalType === activeDocument.documentalType
        )?.idSubSerie as string)
      : "",
    documentalType:
      activeDocument && activeDocument.documentalType
        ? activeDocument.documentalType
        : "",
  });

  const initialValues = {
    productionOffice: "",
    series: "",
    subSeries: "",
    documentalType: "",
  };

  const selectOfficesUser = (userOffice: any[]) => {
    const extractedParts = userOffice.map((item) => {
      const parts = item.split("_");
      return parts.slice(0, 2).join("_");
    });

    const filteredOffices =
      latestProductionOffices?.filter((office) =>
        extractedParts.includes(office.id)
      ) || [];

    return filteredOffices; // Retorna el array de oficinas filtradas
  };

  useEffect(() => {
    // let parseArrFiles: ICheckFiles[] = [];

    // corresAnnotations.forEach((annotation) => {
    //   const { attachedFiles, id } = annotation;
    //   attachedFiles
    //     .filter((file) => !file.trdVersion)
    //     .forEach((file) => {
    //       parseCorresFiles.push({ ...file, annotationId: id });
    //     });
    // });

    if (!activeCorrespondence) {
      throw new Error("no active correspondence");
    }
    if (!user || !user.offices) {
      throw new Error("no tien oficina asociadas");
    }

    if (window.location.pathname.includes("documentmanagment")) {
      //modulño management
      setProductionOffice(selectOfficesUser(user.offices));
    } else {
      // module correspondence
      setProductionOffice(latestProductionOffices);
    }

    let parseArrFilesData: IClassificationTrdFileDoc[] = [];
    parseArrFilesData = CorrespondenceDigitalSupportFileToTrdFileList(
      activeCorrespondence.digitalSupport
    );

    let parseArrAppendDocsFilesData: IClassificationTrdFileDoc[] = [];
    parseArrAppendDocsFilesData = CorrespondenceappendDocsFileToTrdFileList(
      activeCorrespondence.appendDocs || []
    );
    const combinedFilesData = [
      ...parseArrFilesData,
      ...parseArrAppendDocsFilesData,
    ];
    setParseCorresFiles(combinedFilesData);
  }, []);

  const onClose = () => {
    dispatch(setActiveDocument(null));
    dispatch(uiCloseModalAction());
    dispatch(uiCloseModalInfo());
  };

  const handleCheck = (file: IClassificationTrdFileDoc) => {
    setSelectedFile(
      (prev) =>
        prev.some((item) => item.fileName === file.fileName) // Verifica si ya está en la lista
          ? prev.filter((item) => item.fileName !== file.fileName) // Si está, lo elimina
          : [file, ...prev] // Si no está, lo agrega
    );
  };

  const handleSelectAll = () => {
    setSelectedFile(allSelected ? [] : [...parseCorresFiles]);
  };

  const handleSelect = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    operation: any
  ) => {
    setSelected({ ...selected, [event.target.name]: event.target.value });

    switch (operation) {
      case "productionOffice":
        const selectedOfficeSearch = latestProductionOffices.find(
          (office) => office.idProductionOffice === event.target.value
        );
        if (selectedOfficeSearch) {
          setSelectedProductionOffice(selectedOfficeSearch);
        }
        break;
      case "serie":
        const selectedSerieSearch = series.find(
          (data) => data.idSerie === event.target.value
        );
        if (selectedSerieSearch) {
          setSelectedseries(selectedSerieSearch);
        }
        break;
      case "subserie":
        const subserieSearch = subSeries.find(
          (data) => data.idSubserie === event.target.value
        );

        if (subserieSearch) {
          setSelectedsubSeries(subserieSearch);
        }
        break;
      case "documenttype":
        const documentalTypeSearch = documentalType.find(
          (data) => data.idDocumentalType === event.target.value
        );
        if (documentalTypeSearch) {
          setSelecteddocumentalType(documentalTypeSearch);
        }
        break;
      default:
    }
  };

  useEffect(() => {
    //FILTRAR LOS SELECTS
    const seriesFiltered = allSeries.filter(
      (ser) => ser.idProductionOffice === selected.productionOffice
    );
    const subSeriesFiltered = allSubseries.filter(
      (subSer) => subSer.idSerie === selected.series
    );
    const documentalTypeFilter = allDocumentalType.filter(
      (docType) =>
        docType.idProductionOffice === selected.productionOffice &&
        docType.idSerie === selected.series &&
        docType.idSubSerie === selected.subseries
    );
    setSeries(seriesFiltered);
    setSubSeries(subSeriesFiltered);
    setDocumentalType(documentalTypeFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  // const findDocumentalTypeName = (id: string) => {
  //   const docType = allDocumentalType.find(
  //     (doc) => doc.idDocumentalType === id
  //   );
  //   if (docType) {
  //     return docType.name;
  //   }
  //   return "";
  // };

  // if (files.length <= 0) {
  //   return (
  //     <h3>
  //       <FormattedMessage id="NoFilesToClassify" />
  //     </h3>
  //   );
  // }

  const handleSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    setSubmitting(true);

    const data: IClassificationTrdDoc = {
      idEntity: undefined,
      CorrespondenceActive: activeCorrespondence,
      createdAt: "",
      user: undefined,
      FileClasification: selectedFile,
      officeProduction: selectedProductionOffice,
      serie: selectedseries,
      subserie: selectedsubSeries,
      typeDocument: selecteddocumentalType,
      userId: "",
    };

    await dispatch(changeTrdCorrtespondenciafile(data));

    setSubmitting(false);
  };

  return (
    <Formik
      validateOnChange={true}
      initialValues={initialValues}
      //validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, isSubmitting }) => (
        <Form>
          <Grid container>
            <Grid item xs={6}>
              <FormattedMessage id="ProductionOffice" />:
              <Box width={"90%"}>
                <TextField
                  name="productionOffice"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.productionOffice || ""}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "productionOffice")}
                  disabled={disabledOffice}
                >
                  {ProductionOffice.map((productionOffice) => (
                    <MenuItem
                      key={productionOffice.idProductionOffice}
                      value={productionOffice.idProductionOffice}
                    >
                      {productionOffice.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <FormattedMessage id="Series" />:
              <Box width={"90%"}>
                <TextField
                  name="series"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.series || ""}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "serie")}
                  //   disabled={ active ? true : false}
                >
                  {series.map((serie) => (
                    <MenuItem key={serie.idSerie} value={serie.idSerie}>
                      {serie.seriesName}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Grid item xs={6} style={{ marginTop: 18 }}>
              <FormattedMessage id="Subseries" />:
              <Box width={"90%"}>
                <TextField
                  name="subseries"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.subseries || ""}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "subserie")}
                  //   disabled={ active ? true : false}
                >
                  {subSeries.map((subSer) => (
                    <MenuItem key={subSer.idSubserie} value={subSer.idSubserie}>
                      {subSer.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Grid item xs={6} style={{ marginTop: 18 }}>
              <FormattedMessage id="DocumentaryType" />:
              <Box width={"90%"}>
                <TextField
                  name="documentalType"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.documentalType || ""}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "documenttype")}
                  //   disabled={ active ? true : false}
                >
                  {documentalType.map((doc) => (
                    <MenuItem
                      key={doc.idDocumentalType}
                      value={doc.idDocumentalType}
                    >
                      {doc.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 18 }}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          checked={allSelected}
                          indeterminate={
                            selectedFile.length > 0 &&
                            selectedFile.length < parseCorresFiles.length
                          }
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      <TableCell>Nombre del Documento</TableCell>
                      <TableCell>Código TRD</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {parseCorresFiles.map((doc) => (
                      <TableRow key={doc.fileName}>
                        <TableCell>
                          <Checkbox
                            checked={selectedFile.some(
                              (item) => item.fileName === doc.fileName
                            )}
                            onChange={() => handleCheck(doc)}
                          />
                        </TableCell>
                        <TableCell>
                          <a href={doc.url} target="__blank">
                            {doc.fileName}
                          </a>
                        </TableCell>
                        <TableCell>
                          {doc.officeProduction}.{doc.serie}.{doc.subserie}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Box mt={2} display="flex" flexDirection="row-reverse" width={1}>
              {!isSubmitting ? (
                <Button
                  className={clsx(classes.btn, classes.save)}
                  autoFocus
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FormattedMessage id="Save" />
                </Button>
              ) : (
                <Button
                  className={clsx(classes.btn, classes.save)}
                  autoFocus
                  type="button"
                  disabled={true}
                >
                  <CircularProgress className={classes.btnLoading} />
                </Button>
              )}
              <Button
                className={clsx(classes.btn, classes.cancel)}
                onClick={onClose}
              >
                <FormattedMessage id="Cancel" />
              </Button>
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
